var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-background-muted uk-padding uk-padding-remove-horizontal"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }